import React from 'react';
import * as styles from './ToolboxNavigationMinimalItem.style';
import { ToolboxNavigationItemProps } from './ToolboxNavigationItem';

export type ToolboxNavigationMinimalItemProps = Omit<ToolboxNavigationItemProps, 'icon'>;

export const ToolboxNavigationMinimalItem = ({
  label,
  onClick,
  active = false,
  ariaLabel = label,
  title = label,
}) => (
  <button
    css={styles.base}
    onClick={onClick}
    $active={active}
    aria-label={ariaLabel}
    title={title}
  >
    <div css={styles.label}>
      {label}
    </div>
  </button>
);

export default ToolboxNavigationMinimalItem;
